import { Response } from 'superagent'
import { sendRequest } from './superagent'

export async function fetchValues (): Promise<Response> {
  return await sendRequest('get', 'values')
}
